import { useMemo } from 'react';
import { useHouseholdMembersContext } from 'contexts/HouseholdMembersContext';

const isMemberDocumentationCompleted = (member) => {
  const householdAdditionalDetails = member?.additionalDetails?.household ?? {};
  const { documentsUploadCompleted, applicationSubmissionCompleted } =
    householdAdditionalDetails;
  return documentsUploadCompleted && applicationSubmissionCompleted;
};

const useDocumentationProgress = () => {
  const { filteredHouseholdMembers } = useHouseholdMembersContext();

  return useMemo(() => {
    if (!filteredHouseholdMembers?.length) {
      return {
        documentationProgress: 0,
        allMembersHaveCompletedDocumentation: false,
        allFilteredMembersDocumentationCompleted: false,
        isDenied: false,
      };
    }
    for (const member of filteredHouseholdMembers) {
    }
    const allMembersHaveCompletedDocumentation =
      filteredHouseholdMembers?.every((hm) =>
        isMemberDocumentationCompleted(hm),
      );
    const allFilteredMembersDocumentationCompleted =
      filteredHouseholdMembers?.every((hm) =>
        isMemberDocumentationCompleted(hm),
      );

    return {
      allMembersHaveCompletedDocumentation,
      allFilteredMembersDocumentationCompleted,
    };
  }, [filteredHouseholdMembers]);
};

export default useDocumentationProgress;
